export default "__VITE_ASSET__BLiiK7hK__"